import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { CollectionType, GroupType } from '@pages/statistics-page/constants';
import {
  ChartDataRequest,
  ChartDataResponse,
  ColoredStatisticsGroup,
  GetGroupsResponse,
  StatisticsMenuForm,
} from '@pages/statistics-page/interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StatisticsApiService {
  private http = inject(HttpClient);

  fetchGroups(): Observable<GetGroupsResponse[]> {
    const url = `${environment.endpoints.statisticsApi}/getGroups`;
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    return this.http.get<GetGroupsResponse[]>(url, options);
  }

  fetchChartsByType(
    pinnedGroups: ColoredStatisticsGroup[],
    activeMenuFilters: StatisticsMenuForm | undefined,
    collectionType: CollectionType,
    includeGlobalData = false
  ): Observable<ChartDataResponse[]> {
    const url = `${environment.endpoints.statisticsApi}/chartData`;
    const includeCompanyData = !!pinnedGroups.find(
      group => group.type === GroupType.Company
    );

    const request = {
      departmentIds: pinnedGroups.map(group => group.id).filter(id => id >= 0),
      ...activeMenuFilters,
      collectionType,
      includeCompanyData: includeCompanyData,
      includeGlobalData,
    } as ChartDataRequest;

    const body = JSON.stringify(request);
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    return this.http.post<ChartDataResponse[]>(url, body, options);
  }
}
